import { ActionType } from 'deox';
import { call, put } from 'redux-saga/effects';

import { getAppointmentsAction } from '@/redux/actions';
import { getAppointments, TGetAppointmentsResponse } from '@/services/api';

// FUNCTION

export function* getAppointmentsSaga(action: ActionType<typeof getAppointmentsAction.request>): Generator {
  const { materials, successCallback, failedCallback } = action.payload;
  try {
    const response = yield call(getAppointments, materials);
    const getAppointmentsResponse: TGetAppointmentsResponse = response as TGetAppointmentsResponse;
    yield put(getAppointmentsAction.success(getAppointmentsResponse));
    successCallback?.(getAppointmentsResponse);
  } catch (err) {
    yield put(getAppointmentsAction.failure(err));
    failedCallback?.(err);
  }
}
